import { toConversationError } from '@/services/conversations/errors';
import { fetchClient } from '@/util/fetchClient';

/**
 * The signed-in member's own support thread with Primum, created empty on
 * first use. The member-side counterpart of the staff resolve call, which
 * opens any member's thread as Primum Support.
 */
export async function getMySupportThread(): Promise<{ conversationId: string }> {
  try {
    const { data } = await fetchClient.GET('/v2/support/conversation');

    if (!data) {
      throw new TypeError('Empty support conversation response');
    }

    return data.data;
  } catch (error) {
    throw toConversationError(error);
  }
}
